// extracted by mini-css-extract-plugin
export default {"productDescription":"Y--z","featuredDescription":"Z--z","description":"_--z","more":"a_-z","descriptionSku":"b_-z"};